// Module
var code = "<ng-transclude></ng-transclude> <div class=\"preview-toggle\" ng-click=\"openPreview()\" ng-if=\"file\"> <i class=\"fas fa-search-plus fa-lg\"></i> </div> ";
// Exports
module.exports = code;